
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/learn-more",
      function () {
        return require("private-next-pages/docs/learn-more.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/learn-more"])
      });
    }
  